import { render, staticRenderFns } from "./GarageForm.vue?vue&type=template&id=07050b9a&scoped=true&"
import script from "./GarageForm.vue?vue&type=script&lang=js&"
export * from "./GarageForm.vue?vue&type=script&lang=js&"
import style0 from "./GarageForm.vue?vue&type=style&index=0&id=07050b9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07050b9a",
  null
  
)

export default component.exports